import {
  clearMainBridgeReconnectQuietOnOpen,
  recordBridgeSessionOpened,
} from './reconnect/index.js';
import { sendBridgeIdentify } from './send-bridge-identify.js';
import { reportGitRepos } from './report-git-repos.js';
import type { MainBridgeWsLifecycleParams } from './main-bridge-ws-lifecycle-types.js';

export function createMainBridgeOpenHandler(params: MainBridgeWsLifecycleParams): () => void {
  const {
    state,
    getWs,
    workspaceId,
    justAuthenticated,
    logFn,
    tokens,
    e2ee,
    identifyReportedPaths,
    onBridgeSocketOpen,
  } = params;

  return () => {
    recordBridgeSessionOpened(state.duplicateBridgeFlap, Date.now());
    const logOpenAsPostRefreshReconnect = state.logBridgeOpenAsReconnect;
    clearMainBridgeReconnectQuietOnOpen(state, logFn);
    state.reconnectAttempt = 0;
    state.logBridgeOpenAsReconnect = false;
    if (!logOpenAsPostRefreshReconnect) {
      logFn('Connected to bridge service.');
    }
    const socket = getWs();
    if (socket) {
      sendBridgeIdentify(socket, { identifyReportedPaths, e2ee });
      reportGitRepos(getWs, logFn);
      try {
        onBridgeSocketOpen?.();
      } catch {
        /* ignore */
      }
    }
    if (justAuthenticated && socket) {
      logFn(
        'Save these for future runs (access token may rotate; refresh token is stored in ~/.buildautomaton/config.json when you use browser auth):',
      );
      logFn(`  export BUILDAUTOMATON_AUTH_TOKEN="${tokens.accessToken}"`);
      logFn(`  export BUILDAUTOMATON_WORKSPACE_ID="${workspaceId}"`);
    }
  };
}
